import React from 'react'
import { StyleSheet, css } from 'aphrodite'
import { useTranslation } from 'react-i18next'
import {
  COLOR_WHITE,
  COLOR_TURQUOISE__LIGHT,
  COLOR_ORANGE_GRADIENT,
} from '../../lib/colors'
import { leToBr } from '../../utils/Utils'
import {
  IconFacebook,
  IconInstagram,
  IconYoutube,
  IconAppUbqieyes,
} from '../../components/Icon/'
import UILink from '../../components/UI/UILink'
import UIHighlightedTitle from '../../components/UI/UIHighlightedTitle'
import UIPlaystoreButton from '../../components/UI/UIPlaystoreButton'
import UIApplestoreButton from '../../components/UI/UIApplestoreButton'

const styles = StyleSheet.create({
  container: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    overflow: 'hidden',
    color: COLOR_WHITE,
    fontWeight: 700,
    letterSpacing: '-0.03em',
    backgroundColor: COLOR_TURQUOISE__LIGHT,
    padding: '3em 2em 5em 4em',
    '@media (max-width: 480px)': {
      margin: '0',
      padding: '80px 20px 40px 20px',
    },
  },
  containerTitle: {
    display: 'flex',
    alignItems: 'flex-end',
    '@media (max-width: 480px)': {
      flexDirection: 'column',
      alignItems: 'flex-start',
    },
  },
  IconApp: {
    display: 'flex',
    flexDirection: 'row',
    alignSelf: 'center',
    marginTop: '20px',
    height: '100px',
  },
  title: {
    margin: 0,
    fontSize: '4em',
    marginRight: '0.2em',
    '@media (max-width: 480px)': {
      fontSize: '2em',
    },
  },
  socialMediaIcons: {
    marginTop: '50px',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
  },
  now: {
    objectFit: 'cover',
    width: '9em',
  },
  icon: {
    width: '60px',
    marginRight: '40px',
    '@media (max-width: 480px)': {
      marginRight: '0',
      width: '40px',
    },
  },
  icon2: {
    width: '85px',
    marginTop: '-10px',
    '@media (max-width: 480px)': {
      width: '61px',
    },
  },
  subtitle: {
    fontSize: '1.8em',
    alignSelf: 'left',
    marginTop: '2em',
    '@media (max-width: 480px)': {
      marginTop: '3em',
      fontSize: '1em',
    },
  },
  downloadAppButton: {
    marginTop: '8%',
    display: 'flex',
    alignItems: 'center',
    gap: '1em',
    alignSelf: 'center',
    '@media (max-width: 480px)': {
      flexDirection: 'column',
    },
  },
  button: {
    height: '4em',
    cursor: 'pointer',
    '@media (max-width: 480px)': {
      height: 'auto',
      width: '130px',
    },
  },
  everywhere: {
    paddingBottom: '17px',
    fontSize: '4em',
    '@media (max-width: 480px)': {
      fontSize: '2em',
      margin: '10px 0 0 0',
    },
  },
  col: {
    display: 'flex',
    flexDirection: 'column',
  },
  downloadLeft: {
    width: '50%',
  },
  downloadRight: {
    display: 'flex',
    flexDirection: 'column',
    width: '50%',
  },
})

function DownloadApp() {
  const { t } = useTranslation('translation')

  return (
    <>
      <div id="download-app" className={css(styles.container)}>
        <div className={css(styles.downloadLeft)}>
          <div className={css(styles.containerTitle)}>
            <h2 className={css(styles.title)}>
              {leToBr(t('pages.beAMaker.share'))}
            </h2>
            {window.innerWidth < 480 ? (
              <UIHighlightedTitle
                value={t('pages.beAMaker.regard')}
                dynamicStyle={styles.everywhere}
                backgroundColor={COLOR_ORANGE_GRADIENT}
              />
            ) : (
              <div
                style={{
                  transform: 'translateX(-50%)',
                }}
              >
                <UIHighlightedTitle
                  value={t('pages.beAMaker.regard')}
                  dynamicStyle={styles.everywhere}
                  backgroundColor={COLOR_ORANGE_GRADIENT}
                />
              </div>
            )}
          </div>
          <p className={css(styles.subtitle)}>
            {t('pages.beAMaker.downloadAppForMaker')}
          </p>
        </div>
        <div className={css(styles.downloadRight)}>
          <div className={css(styles.socialMediaIcons)}>
            <UILink
              socialIcon={<IconFacebook dynamicStyle={styles.icon} />}
              redirection={
                'https://www.facebook.com/profile.php?id=100085402424868'
              }
              linkStyle="socialMedia"
            />
            <UILink
              socialIcon={<IconInstagram dynamicStyle={styles.icon} />}
              redirection={'https://www.instagram.com/ubiqeyes.maker/'}
              linkStyle="socialMedia"
            />
            <UILink
              socialIcon={<IconYoutube dynamicStyle={styles.icon2} />}
              redirection={'https://www.youtube.com/@ubiqeyes'}
              linkStyle="socialMedia"
            />
          </div>
          <div className={css(styles.IconApp)}>
            <IconAppUbqieyes />
          </div>
          <div className={css(styles.downloadAppButton)}>
            <UIPlaystoreButton dynamicStyle={styles.button} />
            <UIApplestoreButton dynamicStyle={styles.button} />
          </div>
        </div>
      </div>
    </>
  )
}

export default DownloadApp
